import styled from "styled-components";
import CardInfoTextInputs from "./CardInfoTextInputs";
import CardInfoBorderColors from "./CardInfoBorderColors";
import GameDateAndTime from "./GameDateAndTime";
import { CardInfoStyle } from "../common/CardInfoStyle";

const DugoutCardInfoSection = () => {
  return (
    <CardInfoStyle>
      <CardInfoTextInputs />
      <div className="d-flex">
        <CardInfoBorderColors />
        <GameDateAndTime />
      </div>
    </CardInfoStyle>
  );
};

export default DugoutCardInfoSection;
